export default __webpack_public_path__ + "static/inquiry-35777a3ad216beae9c50c676bd6c6946.png";